// Generated using typescript-generator version null on 2019-08-20 09:17:48.

import { Injectable } from '@angular/core';
import { HttpClient, RestResponse, IConfigWebServiceClient, Dto, PaginationResult, PaginateRequestDto } from './resources';

export class CategorieFormulaireDto implements Dto {
  id?: number;
  code?: string;
  libelle?: string;
}

export class LigneInstanceModeleFormulaireDto implements Dto {
  id?: number;
  titreModele?: string;
  categorie?: CategorieFormulaireDto;
  dateCreation?: any;
  statut?: StatutDemandeEnum;
  numeroDossier?: string;
  nomPrenom?: string;
}

export class RechercheInstanceModeleFormulaireDto extends PaginateRequestDto implements Dto {
  titre?: string;
  categories?: CategorieFormulaireDto[];
  statuts?: StatutDemandeEnum[];
  debutDateCreation?: any;
  finDateCreation?: any;
  numeroDossier?: string;
}

export class PaginationInstanceModeleFormulaireResultDto implements Dto {
    limitExceeded: boolean;
    pagination: PaginationResult<LigneInstanceModeleFormulaireDto>;
}

@Injectable()
export class IInstanceModeleFormulaireWebServiceClient {


  protected complementDossierApiUri: string[];

  constructor(protected httpClient: HttpClient, protected configWebServiceClient: IConfigWebServiceClient) {
    this.initApi();
  }

  private async initApi() {
    this.complementDossierApiUri = await this.configWebServiceClient.getComplementDossierApiUri().toPromise();
  }
  /**
   * HTTP POST /instancemodele/search
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IInstanceModeleFormulaireWebService.searchInstanceModeleFormulaire
   */
  searchInstanceModeleFormulaire(arg0: RechercheInstanceModeleFormulaireDto): RestResponse<PaginationInstanceModeleFormulaireResultDto> {
    return this.httpClient.request({ method: 'POST', url: this.complementDossierApiUri[0]+'instancemodele/search', data: arg0 });
  }


  /**
   * HTTP POST /instancemodele/countSearch
   * Java method: fr.cerba.digicerba.formulairedemat.webservices.IInstanceModeleFormulaireWebService.countSearchInstanceModeleFormulaire
   */
  countSearchInstanceModeleFormulaire(arg0: RechercheInstanceModeleFormulaireDto): RestResponse<number> {
    return this.httpClient.request({ method: 'POST', url: this.complementDossierApiUri[0]+'instancemodele/countSearch', data: arg0 });
  }
}

export type StatutDemandeEnum = 'EN_COURS' | 'TERMINE';



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/resources/resources.external.ts